'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPage$DocumentsList(pageCursor, kinds) {
  this.za = null;
  this.BK = null;
  this.za = pageCursor;
  this.BK = kinds;
}
export { $c_Lapp_pages_AppPage$DocumentsList as $c_Lapp_pages_AppPage$DocumentsList };
$p = $c_Lapp_pages_AppPage$DocumentsList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_AppPage$DocumentsList;
/** @constructor */
function $h_Lapp_pages_AppPage$DocumentsList() {
}
export { $h_Lapp_pages_AppPage$DocumentsList as $h_Lapp_pages_AppPage$DocumentsList };
$h_Lapp_pages_AppPage$DocumentsList.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$DocumentsList)) {
    var x = this.za;
    var x$2 = x$0.za;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.BK;
      var x$4 = x$0.BK;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsList";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.za;
  }
  if ((n === 1)) {
    return this.BK;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "pageCursor";
  }
  if ((n === 1)) {
    return "kinds";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$DocumentsList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ka)));
}
export { $isArrayOf_Lapp_pages_AppPage$DocumentsList as $isArrayOf_Lapp_pages_AppPage$DocumentsList };
var $d_Lapp_pages_AppPage$DocumentsList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPage$DocumentsList, "app.pages.AppPage$DocumentsList", ({
  ka: 1,
  aB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPage$DocumentsList as $d_Lapp_pages_AppPage$DocumentsList };
//# sourceMappingURL=app.pages.-App-Page$-Documents-List.js.map
